import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ProductFieldComponent } from './product-field.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
  ],
  declarations: [
    ProductFieldComponent,
  ],
  exports: [
    ProductFieldComponent,
  ],
})
export class ProductsExportModule {}
